import { defineEntitiesSelectors } from '../utils/defineEntitiesSelectors'

export const shiftsBaseSelectors = defineEntitiesSelectors({ type: 'shifts' })
